var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slogan-title"},[_c('div',{staticClass:"blue-title"},[_c('div',{staticClass:"blue-line"}),_c('h4',[_vm._v(_vm._s(_vm.theTitle))])])])}
var staticRenderFns = []

export { render, staticRenderFns }